export var Types = {
    signature: "追签",
    payment: "追账",
};
